/* NSH Notes detail (2026-10-23, v1.1 after feedback) - loaded at the end of sections/main-article-nooysuhsuh.liquid (not deferred:
   the markup above is parsed, so the re-arranging below happens before the first paint in most cases). ASCII except the step-heading regex. Without this
   file the page still reads top to bottom: body as written, then the question box, then author and references.
   1) "One step today": the last h3 of the body whose text matches one of the step headings (any locale), or, failing that, the h3
      right before the FAQ / references that is followed by a list; it and its list are wrapped in div.nshd-step.
   2) FAQ title: the h4 of div.nsh-faq shows the Figma "FAQ" SVG (root data-faq-svg) in every locale, alt "FAQ".
      Answers stay open (no accordion).
   3) References: every div.nsh-sources of the body moves to the left panel (#nshdRefs), before the disclaimer.
   4) Panels: >= 1200px they live in the side columns (sticky, visible from the start, no motion); below, the question box goes
      right after the step box (else before the FAQ, else at the end of the body) and the author panel goes to #nshdAsideM
      (end of the body, before Read next).
   5) Question chips: remember the tapped text for the quiz's "answer from the note" line (localStorage nshNotePre, like
      nsh-note-cta.js), mark the chip, open the quiz 0.2 s later. Modified clicks open normally.
      2026-10-28: the question id comes from the box's data-q (topic question, or concern as the fallback). */
(function () {
  if (window.__NSHD) return; window.__NSHD = 1;
  var D = document, W = window;
  var root = D.querySelector('.nshd'); if (!root) return;
  var body = D.getElementById('nshdBody');
  var sideL = D.getElementById('nshdSideL'), sideR = D.getElementById('nshdSideR');
  var colL = root.querySelector('.nshd-col--l'), colR = root.querySelector('.nshd-col--r');
  var slotM = D.getElementById('nshdAsideM'), refs = D.getElementById('nshdRefs');
  var mq = W.matchMedia ? W.matchMedia('(min-width:1200px)') : null;

  function kids(el, sel) { return [].filter.call(el.children, function (c) { return c.matches(sel); }); }
  function isStop(n) {
    if (!n || n.nodeType !== 1) return false;
    if (/^H[1-3]$/.test(n.tagName) || n.tagName === 'BLOCKQUOTE' || n.tagName === 'DIV' || n.tagName === 'FIGURE' || n.tagName === 'ASIDE') return true;
    return false;
  }

  /* 1) step box */
  var step = null;
  function stepBox() {
    if (!body) return;
    var hs = kids(body, 'h3'), h = null, re = /one step today|오늘|今日/i;  /* "today" in KO / JA, matched only */
    for (var i = hs.length - 1; i >= 0; i--) if (re.test(hs[i].textContent || '')) { h = hs[i]; break; }
    if (!h) {
      var stop = body.querySelector(':scope > .nsh-faq, :scope > .nsh-sources');
      for (var j = hs.length - 1; j >= 0; j--) {
        var nx = hs[j].nextElementSibling;
        if (nx && (nx.tagName === 'UL' || nx.tagName === 'OL')) {
          var e = nx.nextElementSibling;
          while (e && (e.tagName === 'UL' || e.tagName === 'OL' || e.tagName === 'P')) e = e.nextElementSibling;
          if (!e || e === stop) { h = hs[j]; break; }
        }
      }
    }
    if (!h) return;
    var box = D.createElement('div'); box.className = 'nshd-step';
    body.insertBefore(box, h);
    var n = h;
    while (n) {
      var next = n.nextSibling;
      box.appendChild(n);
      n = next;
      if (n && isStop(n)) break;
    }
    /* trailing whitespace / empty text out of the box */
    while (box.lastChild && box.lastChild.nodeType === 3 && !box.lastChild.nodeValue.trim()) body.insertBefore(box.lastChild, box.nextSibling);
    step = box;
  }

  /* 2) FAQ title as the Figma SVG */
  function faqTitle() {
    var src = root.getAttribute('data-faq-svg'); if (!body || !src) return;
    [].forEach.call(body.querySelectorAll('.nsh-faq > h4'), function (h) {
      var im = D.createElement('img');
      im.src = src; im.alt = 'FAQ'; im.width = 31; im.height = 13; im.decoding = 'async';
      h.textContent = ''; h.appendChild(im);
    });
  }

  /* 3) references to the left panel */
  function references() {
    if (!body || !refs) return;
    var list = kids(body, '.nsh-sources');
    var disc = refs.querySelector('.nshd-disc');
    list.forEach(function (s) { refs.insertBefore(s, disc || null); });
  }

  /* 4) panel placement */
  function quizSpot() {
    if (step && step.parentNode === body) return { parent: body, before: step.nextSibling };
    var f = body && body.querySelector(':scope > .nsh-faq');
    if (f) return { parent: body, before: f };
    return body ? { parent: body, before: null } : null;
  }
  function place() {
    var wide = !mq || mq.matches;
    if (wide) {
      if (sideL && colL && sideL.parentNode !== colL) colL.appendChild(sideL);
      if (sideR && colR && sideR.parentNode !== colR) colR.appendChild(sideR);
    } else {
      if (sideL && slotM && sideL.parentNode !== slotM) slotM.appendChild(sideL);
      var sp = quizSpot();
      if (sideR && sp && !(sideR.parentNode === sp.parent && sideR.nextSibling === sp.before)) sp.parent.insertBefore(sideR, sp.before);
    }
  }

  /* 5) question chips */
  function chips() {
    if (!sideR) return;
    sideR.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('.nshd-q__opt');
      if (!a) return;
      try {
        localStorage.setItem('nshNotePre', JSON.stringify({ h: sideR.getAttribute('data-h'), q: sideR.getAttribute('data-q') || 'concern',
          o: a.getAttribute('data-o'), l: sideR.getAttribute('data-l'), t: (a.textContent || '').trim(), ts: Date.now() }));
      } catch (e) {}
      if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button) return;
      ev.preventDefault();
      [].forEach.call(sideR.querySelectorAll('.nshd-q__opt'), function (o) { o.classList.toggle('is-sel', o === a); });
      var href = a.href;
      setTimeout(function () { location.href = href; }, 200);
    });
  }

  try { stepBox(); } catch (e) {}
  try { faqTitle(); } catch (e) {}
  try { references(); } catch (e) {}
  place();
  if (mq) { if (mq.addEventListener) mq.addEventListener('change', place); else if (mq.addListener) mq.addListener(place); }
  chips();
})();
